import React from 'react';
import Link from 'components/link';
import AspectRatio from 'components/aspect-ratio';
import Button from 'components/control/button';
import styles from './style.module.scss';
import { testIds } from 'constants/test-constants';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';

import type { IUserLocation } from 'utils/user-location';

export const CTA_CARD_TYPE_AVAILABLE = 'available' as const;
export const CTA_CARD_TYPE_SOLD = 'sold' as const;
export const CTA_CARD_TYPE_FEATURED = 'featured' as const;

export type CtaCardType = typeof CTA_CARD_TYPE_AVAILABLE | typeof CTA_CARD_TYPE_SOLD | typeof CTA_CARD_TYPE_FEATURED;

export type CTACardProps = {
  type: CtaCardType;
  userLocation: IUserLocation;
  isWidget?: boolean;
  redirectUrl?: string;
};

export default function CTACard({ type, userLocation, redirectUrl }: CTACardProps) {
  const { t } = useTranslation(Namespaces.COMMON);
  let href: string;
  let ctaText: string;

  if (type === CTA_CARD_TYPE_AVAILABLE) {
    href = `/${userLocation?.slug ? userLocation.slug + '-' : '' }real-estate`;
    ctaText = t(LOCALE_COMMON_PATHS.CTA_CARD_AVAILABLE, { defaultValue: 'Filter by price, property type, square footage, and more to find homes for sale in your area.' });
  } else if (type === CTA_CARD_TYPE_SOLD) {
    href = '/search?status=not-available-sold';
    ctaText = t(LOCALE_COMMON_PATHS.CTA_CARD_SOLD, { defaultValue: 'View sold prices for GTA properties dating back to 2003.' }); //'View sold prices for GTA properties dating back to 2003.';
  } else if (type === CTA_CARD_TYPE_FEATURED) {
    href = '/houses';
    ctaText = 'Filter by price, property type, square footage, and more to find homes for sale in your area.';
  }

  href = redirectUrl || href;

  return (
    <div className={styles.component} data-testid={testIds.ctaCard}>
      <div className={styles.top}>
        <AspectRatio ratio="4:3">
          <Image src='/next/assets/images/brush-stroke-2.png' className={styles.image} alt='Brush stroke' fill/>
          <div className={styles.text}>
            <p>Looking for more properties?</p>
            <Link href={href}>
              <Button label="View More" theme="primary" />
            </Link>
          </div>
        </AspectRatio>
      </div>
      <div className={styles.bottom}>
        <p>{ctaText}</p>
      </div>
    </div>
  );
}
